<template>
  <AdminLayout :title="$t('admin_sale_log.sale_completed_title_old')" :current="$c.ADMIN.TAB.SALE">
    <div class="section">
      <div class="container">
        <InputSearch
          type="string" v-model="sale_name" :placeholder='$t("admin_sale_log.search_hint")' @click="search_sale"></InputSearch>
        <b-table
          style="font-size: 0.9em;"
          head-variant="my"
          :items="items"
          :fields="fields"
          class="mt-3"
          bordered>
          <template #cell(ref)="data">
            <b-link style="text-decoration:underline" @click="showSiteDetail(data.value)">{{fields[3].label}}</b-link>
          </template>
        </b-table>
        <p class="p-center" v-if="siteList.length === 0">{{$t('common.empty_hint')}}</p>
      </div>
      <SiteDetail v-if="siteDetailData != null" :visible.sync="showSiteDetailPopup" :site="siteDetailData" />
    </div>
  </AdminLayout>
</template>
<script>
import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import Utils from "../../../../config/utils";
import SiteItem from "../../../controls/SiteItem";
import TransferPopup from "../../../controls/popup/TransferPopup";
import SiteDetail from "../interest/SiteDetail";
import moment from "moment";

export default {
  name: "AdminSaleLogOld",
  components: {
    AdminLayout,
    InputSearch,
    SiteItem,
    TransferPopup,
    SiteDetail,
  },
  data() {
    return {
      sale_name:null,
      siteList: [],
      showTransferPopup:false,
      currentItem: null,
      showSiteDetailPopup: false,
      siteDetailData: null,
      fields:[
        {key:"date",label:this.$t('admin_sale_log.reported_date'), class:'text-center admin-th', thStyle:"width:12%"},
        {key:"number", label:this.$t('admin_sale_log.report_member_number'), class:'text-center admin-th', thStyle:"width:35%"},
        {key:"place", label:this.$t('admin_sale_log.reported_site_name'), class:'text-center admin-th', thStyle:"width:38%"},
        {key:"ref", label:this.$t('admin_sale_log.move'), class:'text-center admin-th', thStyle:"width:15%"},
      ],
      items: []
    }
  },
  methods:{
    search_sale(){
      Utils.requestGet(this.$c.API.Admin.getCompleteReqSiteOld, {
        keyword: this.sale_name
      }).then(result => {
        for(let item of result.data.list){
          this.items.push({
            date: moment(item.f_reg_time).format('MM/DD'),
            number: Utils.formatPhoneNumber(item.f_phone),
            place: item.f_site_name,
            ref: item.f_site_idx,
          });
        }
        this.siteList = result.data.list;
      });
    },

    showSiteDetail(siteIdx) {
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: siteIdx,
        },
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.siteDetailData = result.data;
          this.showSiteDetailPopup = true;
          if (result.data.isHidden) {
            Utils.toast(this, this.$t('common.deleted_hidden_site'));
          }
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },

    onShowTransfer(item){
      this.currentItem = item;
      this.showTransferPopup = true;
    },
    onRemove(idx){
      this.siteList= this.siteList.filter(it => {
        return it.f_idx != idx;
      });
    },
  },
  mounted() {
    this.search_sale();
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
::placeholder{
  color: $text!important;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminSaleLogOld.vue